import(/* webpackMode: "eager" */ "/vercel/path0/app/projects/Simposio/page.tsx");
